module.exports = __webpack_public_path__ + "static/media/HomepageScroll.ef732c3b.svg";